/**
 * @fileoverview
 * Define las rutas de la aplicación y los roles autorizados para acceder a cada una.
 */

import { MASTER, ADMINISTRATOR, EXAMINER, CANDIDATE } from 'utils/roles.js';

/**
 * @constant routeAllowed
 * @description
 * Objeto que mapea rutas a los roles permitidos para acceder a ellas. Se utiliza para validaciones de acceso y navegación protegida.
 *
 * @example
 * routeAllowed['/admin/users'] // [MASTER, ADMINISTRATOR]
 *
 * @type {Object.<string, string[]>}
 */
const routeAllowed = {
	'/': [MASTER, ADMINISTRATOR, EXAMINER, CANDIDATE],

	'/dashboard': [MASTER, ADMINISTRATOR, EXAMINER, CANDIDATE],

	'/admin': [MASTER, ADMINISTRATOR],
	'/admin/users': [MASTER, ADMINISTRATOR],
	'/admin/candidates': [MASTER, ADMINISTRATOR],
	'/admin/colleges': [MASTER, ADMINISTRATOR],
	'/admin/questions/epst': [MASTER, ADMINISTRATOR],
	'/admin/questions/emet': [MASTER, ADMINISTRATOR],

	'/examiner': [MASTER, EXAMINER],
	'/examiner/results/epst': [MASTER, EXAMINER],
	'/examiner/results/emet': [MASTER, EXAMINER],

	'/certification/indications': [CANDIDATE],
	'/certification/emet': [CANDIDATE],
	'/certification/results/emet': [CANDIDATE],
	'/certification/epst': [CANDIDATE],
	'/certification/results/epst': [CANDIDATE]
};

export default routeAllowed;